/**
 * 中型终端
 */
import React from 'react';
import cn from 'classnames';
import Contact from 'components/contact';
import Wrapper from 'components/product/relevance/wrapper';
import MultipleBanner from 'components/product/banner/multiple';
import style from './index.module.scss';
import Medias from 'components/medias';
import Scheme from 'components/product/scheme';
import Transition from 'components/transition';
import { WrapperBanner } from 'components/product/banner';

const IMG_PRE = 'https://sdk-source.xylink.com/website/assets/hardware/hard/ME60S/';
const bannerList = [
  {
    title: '中型会议室\n分体式终端',
    pcUrl: 'bg0.jpg',
    mUrl: 'm/bg0.jpg',
    desc: '4K超高清画面，有效控制利旧成本，轻松升级视频会议体验',
    mDesc: '4K超高清画面，有效控制利旧成本，轻松升级\n视频会议体验',
    type: 4,
    className: style.firstBanner,
  },
  {
    title: '稳定流畅，性能优异',
    pcUrl: 'bg1.jpg',
    mUrl: 'm/bg1.jpg',
    desc: '国产芯片，支持H.265 SVC编解码\n前向纠错、丢包重传、丢包保护\n随时发起视频会议，运行超强稳定',
    type: 3,
    className: style.banner1,
  },
  {
    title: '4K超清，清晰如面聊',
    pcUrl: 'bg2.jpg',
    mUrl: 'm/bg2.jpg',
    desc: '4K超高清显示，画质细腻精致，清晰呈现每个细节\n支持屏幕共享和批注显示，异地协作更轻松',
    mDesc: '4K超高清显示，画质细腻精致，清晰呈现每个\n细节\n支持屏幕共享和批注显示，异地协作更轻松',
    type: 4,
  },
  {
    title: '无限扩展，轻松升级',
    pcUrl: 'bg3.jpg',
    mUrl: 'm/bg3.jpg',
    desc: '支持主流云视频会议平台，麦克风、摄像头按需扩展\n满足利旧升级，无需过多改造，轻松升级视频会议体验',
    mDesc: '支持主流云视频会议平台，麦克风、摄像头按\n需扩展\n满足利旧升级，无需过多改造，轻松升级视频\n会议体验',
    type: 3,
    className: style.banner2,
  },
  {
    title: '全方位拾音，远端听讲“声”临其境',
    mTitle: '全方位拾音\n远端听讲“声”临其境',
    pcUrl: 'bg4.jpg',
    mUrl: 'm/bg4.jpg',
    desc: '实现全方位拾音，搭配智能降噪、消除回声、自动增益等算法\n本地会议发言精准捕捉，远端听讲不遗漏关键信息',
    mDesc: '实现全方位拾音，搭配智能降噪、消除回声、\n自动增益等算法\n本地会议发言精准捕捉，远端听讲不遗漏关键\n信息',
    type: 4,
    className: style.banner3,
  },
];
const features = [
  {
    name: '声音',
  },
  {
    name: '视频',
  },
  {
    name: '控制',
  },
  {
    name: '信令',
  },
  {
    name: '网络',
  },
  {
    name: '电源',
  },
];
const scene = [
  {
    title: '中型会议室商务洽谈',
    pcUrl: IMG_PRE + 'scene-img0.jpg',
  },
  {
    title: '分支机构远程协同',
    pcUrl: IMG_PRE + 'scene-img1.jpg',
  },
  {
    title: '高效学习培训',
    pcUrl: IMG_PRE + 'scene-img2.jpg',
  },
  {
    title: '日常智慧党建',
    pcUrl: IMG_PRE + 'scene-img3.jpg',
  },
];
const scheme = [
  { title: '支持双屏', pcUrl: IMG_PRE + 'scheme-img0.jpg' },
  { title: '支持单屏', pcUrl: IMG_PRE + 'scheme-img1.jpg' },
];
const Me90 = () => {
  return (
    <Wrapper title="中型终端" menuIndex="2" current={3} customClass={style.me60s}>
      {bannerList.map((item: any) => {
        return <MultipleBanner {...item} animate={'fadeIn'} delay={0.5} descCenter key={item.title} imageHost={IMG_PRE} className={cn(style.banner, item.className)} />;
      })}
      <Medias
        title={'极简部署，自由布线'}
        desc={'多媒体总线技术，音频、视频、控制、信令、\n网络、电源六流合一\n轻部署方式，布线便捷，网线连接扩展自由'}
        features={features}
        imgPre={IMG_PRE}
        bgImage={'bg5.jpg'}
        bgImageM={'m/bg5.jpg'}
      />
      <WrapperBanner
        bannerInfo={{
          pcUrl: IMG_PRE + 'bg6.jpg',
          mUrl: IMG_PRE + 'm/bg6.jpg',
          classNames: style.scheme,
        }}
      >
        <div className={style['scheme-content']}>
          {scheme.map((item: any) => {
            return (
              <div key={item.title} className={style['scheme-item']}>
                <Transition>
                  <p className={style['scheme-item-title']}>{item.title}</p>
                </Transition>
                <Transition>
                  <img className={'for-pc'} src={item.pcUrl} alt="" />
                </Transition>
                <Transition>
                  <img className={'for-mobile'} src={item.pcUrl} alt="" />
                </Transition>
              </div>
            );
          })}
        </div>
      </WrapperBanner>
      <Scheme animate="fadeIn" delay={0.5} data={scene} title={'应用场景'} className={style.scene} />
      <Contact className={style.contact} />
    </Wrapper>
  );
};

export default Me90;
